import React from "react";
import { Navbar, NavbarBrand, Container, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";

function ContactHeader() {
  const navigate = useNavigate();

  return (
   <Navbar
  expand="md"
  className="shadow-sm py-3 px-4"
  style={{
    background: "linear-gradient(90deg, #ffffff, #f8fafc)",
    borderBottom: "1px solid #e9ecef",
  }}
>
  <Container className="d-flex justify-content-between align-items-center">

    {/* Logo / Title */}
    <NavbarBrand
      onClick={() => navigate("/")}
      style={{
        fontWeight: "1500",
        fontSize: "34px",
        cursor: "pointer",
        margin:"auto",
        background: "linear-gradient(45deg, #4f46e5, #06b6d4)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        letterSpacing: "1px",
      }}
    >
      Feesworth
    </NavbarBrand>

 

  </Container>
</Navbar>
  );
}

export default ContactHeader;